import Container from '@v2/shared/components/Container';

/**
 * The Klaviyo newsletter embed that used to sit above the legacy footer.
 *
 * This is barely a React component: Klaviyo's onsite script looks for an element
 * carrying `klaviyo-form-<id>` and injects the form into it. Two things follow from
 * that, and both matter.
 *
 * The div stays childless in JSX. React only reconciles what it rendered, so an
 * element it rendered empty is left alone afterwards and Klaviyo's injected markup
 * survives. Give it children — even a placeholder or a spinner — and the two start
 * fighting over the same subtree.
 *
 * Childless is not enough on a server-rendered page, though. Klaviyo arrives through GTM,
 * which runs before our bundle, so it often fills the div before React hydrates, and
 * hydration then finds children the server never rendered: React throws the page's whole
 * root away and re-renders it on the client. That was the steady "Hydration failed" in
 * Airbrake on every page with this footer. An empty `dangerouslySetInnerHTML` tells React
 * the div's contents are not its business — hydration skips them, and since the value
 * never changes React never writes them afterwards either.
 *
 * The form id is the one the legacy template used, so this stays the same Klaviyo
 * form: its submissions, stats and flows carry over rather than starting fresh under
 * a new id. It is hardcoded for the same reason every other link in this footer is —
 * this component is DiscountMags' footer, not a generic one.
 *
 * Nothing here loads Klaviyo's script, and that is deliberate. It arrives only through
 * Google Tag Manager, which is where cookie consent is enforced, so a visitor who has
 * not opted in never has it requested. The consequence is that this block renders
 * empty for those visitors — which is the intended outcome, not a fault to work
 * around. Loading the script directly would show the form to everyone and take the
 * consent decision away from the visitor.
 *
 * An unfilled container collapses to nothing: the wrapper has no height of its own, so
 * the page reads as though the newsletter were simply absent.
 */
const KLAVIYO_FORM_ID = 'VRGeqq';

export default function NewsletterSignup() {
    return (
        <div className="bg-slate-950">
            <Container>
                <div className={`klaviyo-form-${KLAVIYO_FORM_ID}`} dangerouslySetInnerHTML={{ __html: '' }} />
            </Container>
        </div>
    );
}
